import { render, staticRenderFns } from "./BattleUserAgreements.vue?vue&type=template&id=89d3b16a&scoped=true"
import script from "./BattleUserAgreements.vue?vue&type=script&lang=js"
export * from "./BattleUserAgreements.vue?vue&type=script&lang=js"
import style0 from "./BattleUserAgreements.vue?vue&type=style&index=0&id=89d3b16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d3b16a",
  null
  
)

export default component.exports